import React, { useState } from 'react';
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';
import Confetti from './Confetti';

const ConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = "Confirm",
    cancelText = "Cancel",
    type = "info", // "success", "warning", "info"
    showConfetti = false // New prop for celebrations!
}) => {
    const [confettiComplete, setConfettiComplete] = useState(false);
    if (!isOpen) return null;

    const getIcon = () => {
        switch (type) {
            case 'success':
                return <CheckCircle className="text-success" size={48} />;
            case 'warning':
                return <AlertCircle className="text-warning" size={48} />;
            default:
                return <Info className="text-primary" size={48} />;
        }
    };

    const getButtonColor = () => {
        switch (type) {
            case 'success':
                return 'bg-success hover:bg-success/80 text-success-content';
            case 'warning':
                return 'bg-warning hover:bg-warning/80 text-warning-content';
            default:
                return 'bg-primary hover:bg-primary/80 text-primary-content';
        }
    };

    return (
        <>
            {/* Confetti celebration! */}
            {showConfetti && isOpen && !confettiComplete && (
                <Confetti onComplete={() => setConfettiComplete(true)} />
            )}

            <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-50 font-mono">
                <div className="bg-base border-2 border-primary rounded-2xl max-w-md w-full p-6 shadow-2xl animate-fadeIn">
                    {/* Close button */}
                    {onClose && (
                        <button
                            onClick={onClose}
                            className="absolute top-4 right-4 text-muted hover:text-main transition-colors"
                            aria-label="Close"
                        >
                            <X size={20} />
                        </button>
                    )}

                    {/* Icon */}
                    <div className="flex justify-center mb-4">
                        {getIcon()}
                    </div>

                    {/* Title */}
                    {title && (
                        <h2 className="text-2xl font-bold text-main text-center mb-3">
                            {title}
                        </h2>
                    )}

                    {/* Message */}
                    <p className="text-main text-center mb-6 leading-relaxed">
                        {message}
                    </p>

                    {/* Buttons */}
                    <div className="flex gap-3">
                        {cancelText && onClose && (
                            <button
                                onClick={onClose}
                                className="flex-1 py-3 px-4 bg-surface hover:bg-surface-hover text-main border border-border rounded-xl font-bold transition-colors"
                            >
                                {cancelText}
                            </button>
                        )}
                        {confirmText && onConfirm && (
                            <button
                                onClick={() => {
                                    onConfirm();
                                    if (onClose) onClose();
                                }}
                                className={`flex-1 py-3 px-4 rounded-xl font-bold transition-colors ${getButtonColor()}`}
                            >
                                {confirmText}
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ConfirmModal;
